import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Alert, Box, Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import { AxiosResponse } from "axios";
import { useGlobalState } from "../../contexts/GlobalContext";
import {
  checkEmailExists,
  updateUserMetadata,
  getDetailSF,
  handleFetchContactInfo,
  handleSyncCustomerInfo,
} from "../../utils/helpers/api";
import { Http, Regex } from "../../utils/constants";
import Input from "../../components/Commons/Input";

const OptOutNotification: React.FC = () => {
  const { t } = useTranslation();
  const { setStateValue, globalState } = useGlobalState();
  const [state, setState] = useState<INotificationFormState>({
    data: {},
    isSuccess: false,
    email: "",
    dataSFOtp: {},
  });
  const { data, email, dataSFOtp } = state;
  const { newsletterSubscription } = data ?? {};
  const [errors, setErrors] = useState({
    email: "",
  });
  const [Newsletter21__c, setNewsletter21__c] = useState(false);
  const [Newsletter22__c, setNewsletter22__c] = useState(false);
  const [Newsletter23__c, setNewsletter23__c] = useState(false);

  const handleGetContactId = async () => {
    try {
      const query = `SELECT Id FROM Contact WHERE Email = '${encodeURIComponent(
        email ?? ""
      )}'`;
      try {
        const accountSfDetail = await getDetailSF(query);
        const id =
          accountSfDetail.data.records.length > 0
            ? accountSfDetail.data.records?.[0]?.Id
            : "";
        if (id) {
          const contactInfo = await handleFetchContactInfo(id);
          const dataUpdate: any = {
            SsoID__c: contactInfo.data.SsoID__c,
            LastName: contactInfo.data.LastName,
            FirstName: contactInfo.data.FirstName,
            NameKana__pc: contactInfo.data.NameKana__c,
            Company__pc: contactInfo.data.Company__c,
            PersonMailingPostalCode: contactInfo.data.MailingPostalCode,
            PersonMailingState: contactInfo.data.MailingState,
            PersonMailingCity: contactInfo.data.MailingCity,
            PersonMailingStreet: contactInfo.data.MailingStreet,
            PersonEmail: contactInfo.data.Email,
            /*
            Newsletter1__pc: !newsletterSubscription?.editorialBooks,
            Newsletter3__pc: !newsletterSubscription?.editorialBrain,
            Newsletter5__pc: !newsletterSubscription?.editorialHansokukaigi,
            Newsletter7__pc: !newsletterSubscription?.editorialKohokaigi,
            Newsletter9__pc: !newsletterSubscription?.editorialSendenkaigi,
            Newsletter10__pc: !newsletterSubscription?.classInfo,
            Newsletter17__pc: !newsletterSubscription?.adPlacementSponsorship,
            */
            // SalesPermission_educ_sdk__pc:
            //   !dataSFOtp?.SalesPermission_educ_sdk__pc,
            // SalesPermission_ad_sdk__pc: !dataSFOtp?.SalesPermission_ad_sdk__pc,
            // SalesPermission_award_sdk__pc:
            //   !dataSFOtp?.SalesPermission_award_sdk__pc,
            // SalesPermission_educ_kankyo__pc:
            //   !dataSFOtp?.SalesPermission_educ_kankyo__pc,
            // SalesPermission_ad_kankyo__pc:
            //   !dataSFOtp?.SalesPermission_ad_kankyo__pc,

            // SalesPermission_educ_sdk__c:
            //   !newsletterSubscription?.businessCardExchangeList,
            // SalesPermission_ad_sdk__c:
            //   !newsletterSubscription?.businessCardExchangeList,
            // SalesPermission_award_sdk__c:
            //   !newsletterSubscription?.businessCardExchangeList,
            // SalesPermission_educ_kankyo__c:
            //   !newsletterSubscription?.businessCardExchangeList,
            // SalesPermission_ad_kankyo__c:
            //   !newsletterSubscription?.businessCardExchangeList,
          };
          if (newsletterSubscription?.editorialBooks) {
            dataUpdate.Newsletter1__pc = false;
          }
          if (newsletterSubscription?.editorialBrain) {
            dataUpdate.Newsletter3__pc = false;
          }
          if (newsletterSubscription?.editorialHansokukaigi) {
            dataUpdate.Newsletter5__pc = false;
          }
          if (newsletterSubscription?.editorialKohokaigi) {
            dataUpdate.Newsletter7__pc = false;
          }
          if (newsletterSubscription?.editorialSendenkaigi) {
            dataUpdate.Newsletter9__pc = false;
          }
          if (newsletterSubscription?.classInfo) {
            dataUpdate.Newsletter10__pc = false;
          }
          if (
            newsletterSubscription?.adPlacementSponsorship
          ) {
            dataUpdate.Newsletter17__pc = false;
          }
          if (
            Newsletter21__c
          ) {
            dataUpdate.Newsletter21__c = false;
          }
          if (
            Newsletter22__c
          ) {
            dataUpdate.Newsletter22__c = false;
          }
          if (
            Newsletter23__c
          ) {
            dataUpdate.Newsletter23__c = false;
          }
          await handleSyncCustomerInfo(dataUpdate ?? {});
        }
        if(accountSfDetail.status == 200) {
          return accountSfDetail;
        }
      } catch (error) {
        return error;
      }
    } catch (error) {
      return error;
    }
  };

  const handleChange =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      setState((prevState) => ({
        ...prevState,
        data: {
          ...prevState?.data,
          newsletterSubscription: {
            ...(prevState?.data?.newsletterSubscription ?? {}),
            [field]: checked,
          },
        },
      }));
    };

  const handleChangeDataOTPSF =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
      const checked = event.target.checked;
      setState((prevState) => ({
        ...prevState,
        dataSFOtp: {
          ...(prevState?.dataSFOtp ?? {}),
          [field]: checked,
        },
      }));
    };

  const handleChangeMail = (field: string, value?: string) => {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));
  };

  const handleUpdateMetaData = async () => {
    setStateValue("loader", true);
    try {
      let user_id = "";
      let dataUpdate: IUserMetaDataApi = {};
      const response = await checkEmailExists(email ?? "");
      if (response && !response.data.exists) {
        setErrors((prevState) => ({
          ...prevState,
          email: "入力されたメールアドレスは存在しません。",
          isValid: false,
        }));
        return;
      }
      // user_id = response.data.user.user_id;
      // const { user_metadata } = response.data.user ?? {};
      // const existsNewsletterSubscription = user_metadata?.newsletterSubscription;
      // dataUpdate = {
      //   ...user_metadata,
      //   newsletterSubscription: {
      //     ...user_metadata.newsletterSubscription,
      //     // businessCardExchangeList:
      //     //   !data.newsletterSubscription?.businessCardExchangeList,
      //     editorialBooks: newsletterSubscription?.editorialBooks
      //       ? false
      //       : existsNewsletterSubscription?.editorialBooks,
      //     editorialBrain: newsletterSubscription?.editorialBrain
      //       ? false
      //       : existsNewsletterSubscription?.editorialBrain,
      //     editorialHansokukaigi: newsletterSubscription?.editorialHansokukaigi
      //       ? false
      //       : existsNewsletterSubscription?.editorialHansokukaigi,
      //     editorialKohokaigi: newsletterSubscription?.editorialKohokaigi
      //       ? false
      //       : existsNewsletterSubscription?.editorialKohokaigi,
      //     editorialSendenkaigi: newsletterSubscription?.editorialSendenkaigi
      //       ? false
      //       : existsNewsletterSubscription?.editorialSendenkaigi,
      //     classInfo: newsletterSubscription?.classInfo
      //       ? false
      //       : existsNewsletterSubscription?.classInfo,
      //     adPlacementSponsorship: newsletterSubscription?.adPlacementSponsorship
      //       ? false
      //       : existsNewsletterSubscription?.adPlacementSponsorship,
      //   },
      // };
      // const result = await updateUserMetadata(email ?? "", user_id ?? "", dataUpdate);
      const resContactId = await handleGetContactId() as AxiosResponse;
      if (resContactId?.status === Http.SUCCESS_CODE) {
        setState((prevState) => ({
          ...prevState,
          isSuccess: true,
        }));
        setErrors((prevState) => ({
          ...prevState,
          email: "",
          isValid: false,
        }));
      }
    } catch (err) {
      if (!(err instanceof Error)) {
        const res = err as AxiosResponse;
        return res;
      }
    } finally {
      setStateValue("loader", false);
    }
  };

  const handleSubmit = () => {
    const lowerCaseEmail = (email ?? "").toLowerCase();
    let isValid = false;
    let newErrors = { email: "" };
    if (!lowerCaseEmail) {
      isValid = false;
      newErrors.email = "メールアドレス欄は必須です。";
    }

    if (!lowerCaseEmail) {
      isValid = false;
      newErrors.email = "メールアドレス欄は必須です。";
    } else if (lowerCaseEmail.length > 256) {
      isValid = false;
      newErrors.email = "メールアドレス欄は256文字を超えてはいけません。";
    } else if (!Regex.RULE.EMAIL.test(lowerCaseEmail)) {
      isValid = false;
      newErrors.email = "メールアドレスを正しく入力してください";
    } else {
      newErrors.email = "";
      isValid = true;
    }

    setErrors((prevState) => ({
      ...prevState,
      email: newErrors.email,
    }));

    if (isValid) {
      setState((prevState) => ({
        ...prevState,
        email: lowerCaseEmail,
      }));
      handleUpdateMetaData();
    }
  };

  return (
    <Box className="page__business_card_opt_out">
      <h1 className="header-tit">
        {t("features.emailSetting.businessCardOptOut.headTit")}
      </h1>
      {state.isSuccess && (
        <div className="mb-3">
          <Alert
            sx={{
              bgcolor: "#dff0d8",
              color: "#3c763d",
            }}
            icon={false}
            severity="success"
            onClose={() => {
              setState((prevState) => ({
                ...prevState,
                isSuccess: false,
              }));
            }}
          >
            {t("features.notification.updateMessage")}
          </Alert>
        </div>
      )}
      <p>
        停止希望の方は
        <span style={{ color: "red", fontWeight: "bold" }}>
          チェックを入れて
        </span>
        「チェックを入れたメルマガを停止する」をクリックしてください。
      </p>
      <hr />
      <dl className="unsubscribe-body">
        <div className="body-item item_confirm">
          <dt className="-middle">
            <label>
              {t("general.email")}
              <span className="item_required">{t("general.required")}</span>
            </label>
          </dt>
          <dd>
            <div className="form-col -col2 ">
              <div className=" w-100 form-col_item">
                <Input
                  validateMess={errors.email}
                  error={errors.email}
                  placeholder="taro@example.com"
                  name="email"
                  id="email"
                  value={email ?? ""}
                  onChange={(value) => {
                    handleChangeMail("email", value);
                  }}
                  withChecked={false}
                />
              </div>
            </div>
          </dd>
        </div>
        <div className="body-item item_confirm">
          <dt className="-middle"></dt>
          <dd>
            <div className="form-col -col2 ">
              <div className=" w-100 form-col_item ">
                <ul className="checkbox-list">
                  {/* <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="businessCardExchangeList"
                          onChange={handleChange("businessCardExchangeList")}
                          checked={
                            newsletterSubscription?.businessCardExchangeList ??
                            false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={t(
                        "features.emailSetting.businessCardOptOut.optOutList.meetOrExchangeCards.title"
                      )}
                    />
                  </li> */}
                  {/* <p>
                    {t(
                      "features.emailSetting.businessCardOptOut.optOutList.meetOrExchangeCards.description"
                    )}
                  </p> */}
                  {/* <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="SalesPermission_educ_sdk__pc"
                          onChange={handleChangeDataOTPSF(
                            "SalesPermission_educ_sdk__pc"
                          )}
                          checked={
                            dataSFOtp?.SalesPermission_educ_sdk__pc ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 教育営業 可能"}
                      className="form-label-item"
                    />
                  </li> */}
                  {/* <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="SalesPermission_ad_sdk__pc"
                          onChange={handleChangeDataOTPSF(
                            "SalesPermission_ad_sdk__pc"
                          )}
                          checked={
                            dataSFOtp?.SalesPermission_ad_sdk__pc ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 広告営業 可能"}
                      className="form-label-item"
                    />
                  </li> */}
                  {/* <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="SalesPermission_award_sdk__pc"
                          onChange={handleChangeDataOTPSF(
                            "SalesPermission_award_sdk__pc"
                          )}
                          checked={
                            dataSFOtp?.SalesPermission_award_sdk__pc ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 アワード営業 可能"}
                      className="form-label-item"
                    />
                  </li> */}
                  {/* <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="SalesPermission_educ_kankyo__pc"
                          onChange={handleChangeDataOTPSF(
                            "SalesPermission_educ_kankyo__pc"
                          )}
                          checked={
                            dataSFOtp?.SalesPermission_educ_kankyo__pc ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"環境ビジネス 教育営業 可能"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="SalesPermission_ad_kankyo__pc"
                          onChange={handleChangeDataOTPSF(
                            "SalesPermission_ad_kankyo__pc"
                          )}
                          checked={
                            dataSFOtp?.SalesPermission_ad_kankyo__pc ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"環境ビジネス 広告営業 可能"}
                      className="form-label-item"
                    />
                  </li> */}
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter10__pc"
                          onChange={handleChange("classInfo")}
                          checked={newsletterSubscription?.classInfo ?? false}
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 教育講座のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter17__c"
                          onChange={handleChange("adPlacementSponsorship")}
                          checked={
                            newsletterSubscription?.adPlacementSponsorship ??
                            false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 イベントのメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter1__c"
                          onChange={handleChange("editorialBooks")}
                          checked={
                            newsletterSubscription?.editorialBooks ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"宣伝会議 書籍のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter9__c"
                          onChange={handleChange("editorialSendenkaigi")}
                          checked={
                            newsletterSubscription?.editorialSendenkaigi ??
                            false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"月刊「宣伝会議」編集部のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter5__c"
                          onChange={handleChange("editorialHansokukaigi")}
                          checked={
                            newsletterSubscription?.editorialHansokukaigi ??
                            false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"月刊「広報会議」編集部のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter7__c"
                          onChange={handleChange("editorialKohokaigi")}
                          checked={
                            newsletterSubscription?.editorialKohokaigi ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"月刊「販促会議」編集部のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter3__c"
                          onChange={handleChange("editorialBrain")}
                          checked={
                            newsletterSubscription?.editorialBrain ?? false
                          }
                          sx={{
                            "& .MuiSvgIcon-root": {
                              fontSize: "16px",
                            },
                          }}
                          size="small"
                        />
                      }
                      label={"月刊「ブレーン」編集部のメールマガジン"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter21__c"
                          onChange={(e) => setNewsletter21__c(e.target.checked)}
                          checked={Newsletter21__c}
                          sx={{ "& .MuiSvgIcon-root": { fontSize: "16px" } }}
                          size="small"
                        />
                      }
                      label={"環境ビジネス 教育講座のお知らせ"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter22__c"
                          onChange={(e) => setNewsletter22__c(e.target.checked)}
                          checked={Newsletter22__c}
                          sx={{ "& .MuiSvgIcon-root": { fontSize: "16px" } }}
                          size="small"
                        />
                      }
                      label={"環境ビジネス イベントのお知らせ"}
                      className="form-label-item"
                    />
                  </li>
                  <li>
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Newsletter23__c"
                          onChange={(e) => setNewsletter23__c(e.target.checked)}
                          checked={Newsletter23__c}
                          sx={{ "& .MuiSvgIcon-root": { fontSize: "16px" } }}
                          size="small"
                        />
                      }
                      label={"環境ビジネス 編集部メルマガ"}
                      className="form-label-item"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </dd>
        </div>
      </dl>
      <hr />
      <div className="text-center mt-4">
        <Button
          className="btn form-control btn-mw-270px bg-deep-green"
          onClick={handleSubmit}
        >
          {t("features.emailSetting.businessCardOptOut.saveForm")}
        </Button>
      </div>
    </Box>
  );
};

export default OptOutNotification;
